import {
  BookOpen,
  GraduationCap,
  FileSignature,
  Scale,
  Shield,
  AlertTriangle,
  ScrollText,
  Database,
  TrendingUp,
  Plug,
  Rocket,
  type LucideIcon,
} from 'lucide-react';

export interface ResourceItem {
  icon: LucideIcon;
  title: string;
  description: string;
  href: string;
}

export interface ResourceSection {
  title: string;
  items: ResourceItem[];
}

export const resourceSections: ResourceSection[] = [
  {
    title: 'Ventas',
    items: [
      {
        icon: BookOpen,
        title: 'Guia de Producto',
        description: 'Conoce todas las funcionalidades de PricingIntelligence en detalle.',
        href: '/docs/product-guide',
      },
      {
        icon: TrendingUp,
        title: 'ROI y Beneficios',
        description: 'Calcula el retorno de inversion y descubre los beneficios por rol.',
        href: '/docs/roi',
      },
      {
        icon: Plug,
        title: 'Integraciones',
        description: 'SAP, API REST, webhooks y conectores de e-commerce disponibles.',
        href: '/docs/integrations',
      },
      {
        icon: Rocket,
        title: 'Implementacion',
        description: 'Proceso de onboarding, timeline y requisitos para implementar la plataforma.',
        href: '/docs/implementation',
      },
    ],
  },
  {
    title: 'Documentacion',
    items: [
      {
        icon: BookOpen,
        title: 'Guia Rapida',
        description:
          'Empieza a usar PricingIntelligence en minutos con nuestra guia de inicio rápido.',
        href: '/docs/quick-start',
      },
      {
        icon: GraduationCap,
        title: 'Manual de Usuario',
        description: 'Documentación completa de todas las funcionalidades de la plataforma.',
        href: '/docs/help',
      },
    ],
  },
  {
    title: 'Legal',
    items: [
      {
        icon: FileSignature,
        title: 'Contrato SaaS',
        description: 'Contrato de licencia de software como servicio para clientes empresariales.',
        href: '/contract',
      },
      {
        icon: Scale,
        title: 'Terminos y Condiciones',
        description: 'Terminos de uso de la plataforma PricingIntelligence.',
        href: '/terms',
      },
      {
        icon: Shield,
        title: 'Politica de Privacidad',
        description: 'Como recopilamos, usamos y protegemos tus datos personales.',
        href: '/privacy',
      },
      {
        icon: AlertTriangle,
        title: 'Politica de Uso Aceptable',
        description: 'Reglas de uso responsable de la plataforma.',
        href: '/acceptable-use',
      },
      {
        icon: ScrollText,
        title: 'Aviso Legal',
        description: 'Información legal del sitio web y datos del titular.',
        href: '/legal-notice',
      },
      {
        icon: Database,
        title: 'Acuerdo de Procesamiento de Datos',
        description: 'Condiciones del tratamiento de datos personales (DPA).',
        href: '/data-processing',
      },
    ],
  },
];
